export function useCustomMeta(path, name, prefName) {
  const route = useRoute()
  const config = useRuntimeConfig()
  const baseUrl = `${config.public.hostDomain}${config.app.baseURL}`
  const pageUrl = `${baseUrl}${route.path.replace(/^\//, '')}`
  const tdConfig = () => {
    if (path === 'top') {
      return {
        title: '風の予報（風レーダー）',
        description: '【風レーダー｜ウェザーニュース】風の予報(予測)ならウェザーニュースのサイトをチェック。今日から72時間先までの風の強さ、風向・風速を、色分けされたマップで確認できます。雨雲レーダーや週間天気、台風情報もあわせてご確認ください。最新の気象・防災情報は予報精度No.1ウェザーニュースで。',
        keyword: '風の予報,風レーダー,ウェザーニュース'
      }
    } else if (path === 'area') {
      return {
        title: `${name}の風の予報（風レーダー）`,
        description: `【${name}の風レーダー｜ウェザーニュース】${name}各地の風の予報(予測)ならウェザーニュースのサイトをチェック。今日から72時間先までの風の強さ、風向・風速を、色分けされたマップで確認できます。雨雲レーダーや週間天気、台風情報もあわせてご確認ください。最新の気象・防災情報は予報精度No.1ウェザーニュースで。`,
        keyword: `${name},風の予報,風レーダー,ウェザーニュース`
      }
    } else if (path === 'pref') {
      return {
        title: `${name}の風の予報（風レーダー）`,
        description: `【${name}の風レーダー｜ウェザーニュース】${name}の風の予報(予測)ならウェザーニュースのサイトをチェック。今日から72時間先までの風の強さ、風向・風速を、色分けされたマップで確認できます。雨雲レーダーや週間天気、台風情報もあわせてご確認ください。最新の気象・防災情報は予報精度No.1ウェザーニュースで。`,
        keyword: `${name},風の予報,風レーダー,ウェザーニュース`
      }
    } else if (path === 'city') {
      return {
        title: `${name}の風の予報（風レーダー）`,
        description: `【${name.replace(prefName, '')}の風レーダー｜ウェザーニュース】${name.replace(prefName, '')}の風の予報(予測)ならウェザーニュースのサイトをチェック。今日から72時間先までの風の強さ、風向・風速を、色分けされたマップで確認できます。雨雲レーダーや週間天気、台風情報もあわせてご確認ください。最新の気象・防災情報は予報精度No.1ウェザーニュースで。`,
        keyword: `${name.replace(prefName, '')},風の予報,風レーダー,ウェザーニュース`
      }
    }
  }
  useSeoMeta({
    ogImage: 'https://gvs.weathernews.jp/common/images/ogp/wind.png',
    ogType: 'website',
    ogSiteName: 'ウェザーニュース',
    viewport: 'width=device-width,initial-scale=1.0,minimum-scale=1.0,maximum-scale=3.0,user-scalable=yes',
    twitterCard: 'summary_large_image',
    twitterSite: '@wni_jp',
    twitterCreator: '@wni_jp',
    fbAppId: '1500388770270212',
    appleItunesApp: 'app-id=302955766',
    appleMobileWebAppCapable: 'yes',
    formatDetection: 'address=no'
  })
  useSeoMeta({
    title: `${tdConfig().title} - ウェザーニュース`,
    description: tdConfig().description,
    ogTitle: `${tdConfig().title} - ウェザーニュース`,
    ogDescription: tdConfig().description,
    ogUrl: pageUrl,
    appleMobileWebAppTitle: tdConfig().title,
    keywords: tdConfig().keyword
  })
  useHead({
    link: [
      { rel: 'canonical', href: pageUrl },
      { rel: 'preconnect', href: config.public.siteDataDomain, crossorigin: 'anonymous' },
      { rel: 'dns-prefetch', href: config.public.siteDataDomain },
      { rel: 'dns-prefetch', href: 'https://gvs.weathernews.jp/' },
      { rel: 'dns-prefetch', href: 'https://gis.weathernews.jp' }
    ]
  })
}
